module.exports = "pegasus_template/assets/blocks/column-16-theme5.png";